import styled from 'styled-components';

export default styled.div`
  width: 100%;
  height: 100%;
  top: 0;
  position: absolute;
  background: rgb(171 171 171 / 95%);
  z-index: 2;
  font-size: 2rem;
  display: flex;
  justify-content: center;
  align-items: end;
  padding-bottom: 5%;
  color: #535353;
  font-weight: 700;
`;


